import angular from 'angular';
import constants from 'app/constants';
import {
  pmDataService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './delete-endnote-confirm-dialog.controller';
import template from './delete-endnote-confirm-dialog.html';


class dialogService {
  getOptions($event, {
    customerId,
    endnote,
    updateCallBack,
  }) {
    return {
      controller,
      controllerAs: 'deleteConfirmDialogVM',
      locals: {
        customerId,
        endnote,
        updateCallBack,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.deleteEndnoteConfirmDialog', [
  alerts,
  pmDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('deleteEndnoteConfirmDialog', dialogService)
  .name;
